// Подписка на media-query без библиотек. Нужна мобильной раскладке.

import { useEffect, useState } from 'react'

export function useMediaQuery(query: string): boolean {
  const [match, setMatch] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches,
  )

  useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = () => setMatch(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return match
}

/** Мобильная раскладка: одна панель на весь экран.
 *
 *  Два условия, а не одно.
 *
 *  1. `max-width: 719px` — портретный рубеж из MOBILE_CONTRACT: 719 — телефон,
 *     720 — десктоп. Не трогаем.
 *
 *  2. Низкий и при этом неширокий экран — это тот же телефон, повёрнутый вбок:
 *     ландшафт iPhone 14 — 844x390, узкого Android — 740x360. По одной ширине
 *     они проходили как десктоп, и поворот телефона монтировал десктопный грид
 *     (шапка, бровка раскладок, сетка окон, статус-бар) на экране высотой
 *     360–390 px: кнопки шапки резались справа, а грид ещё и добирал сессии
 *     в paneIds и открывал окно беседы с вебсокетом.
 *
 *  Порог по высоте 500 px берёт весь ландшафт телефонов (самый высокий —
 *  Pro Max, 430 px) и не задевает планшеты: iPad в ландшафте — 1024x768.
 *  Ограничение по ширине 1023 px оставляет настоящему десктопу право на
 *  низкое окно: на широком мониторе полоса высотой 400 px — это осознанно
 *  подобранное окно, а не повёрнутый телефон.
 *
 *  Проверка по углам: 719x900 — мобильная, 720x900 — десктопная,
 *  844x390 и 740x360 — мобильная, 1024x768 и 1920x1080 — десктопная.
 */
export const MOBILE_QUERY =
  '(max-width: 719px), (max-height: 500px) and (max-width: 1023px)'
